export default __webpack_public_path__ + "static/media/wall_active.0e6ab680.svg";